<div class="content-heading" *ngIf="showTitleBar">
  <div>
    {{pageTitle}}
    <small>{{pageSubtitle}}</small>
  </div>
</div>
